import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TextFieldTailwind from './TextFieldTailwind';
import ClientProvider from './client';
export default createDemo(import.meta.url, TextFieldTailwind, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/tailwindcss/demos/text-field-tailwind/TextFieldTailwind.tsx",
    "fileName": "TextFieldTailwind.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import FormControl from '@mui/material/FormControl';\nimport InputLabel from '@mui/material/InputLabel';\nimport Input from '@mui/material/Input';\nimport FormHelperText from '@mui/material/FormHelperText';\n\nexport default function TextFieldTailwind() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <FormControl>\n      <InputLabel\n        shrink\n        htmlFor=\"component-outlined\"\n        className=\"relative top-0 left-0 transform-none text-sm font-medium text-neutral-800 dark:text-neutral-200 pointer-events-auto mb-0.5\"\n      >\n        Name\n      </InputLabel>\n      <Input\n        id=\"component-outlined\"\n        placeholder=\"Type your name\"\n        slotProps={{\n          root: {\n            className:\n              'mt-0 -ml-0.5 px-2 h-10 border-1 border-neutral-300 dark:border-neutral-700 rounded-md has-[input:focus-visible]:outline-2 has-[input:focus-visible]:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm before:hidden after:hidden',\n          },\n          input: {\n            className:\n              'placeholder:opacity-100 placeholder:text-neutral-400 dark:placeholder:text-neutral-500',\n          },\n        }}\n      />\n      <FormHelperText className=\"ml-0\">Some important helper text</FormHelperText>\n    </FormControl>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 33,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import FormControl from '@mui/material/FormControl';\nimport InputLabel from '@mui/material/InputLabel';\nimport Input from '@mui/material/Input';\nimport FormHelperText from '@mui/material/FormHelperText';\n\nexport default function TextFieldTailwind() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <FormControl>\n      <InputLabel\n        shrink\n        htmlFor=\"component-outlined\"\n        className=\"relative top-0 left-0 transform-none text-sm font-medium text-neutral-800 dark:text-neutral-200 pointer-events-auto mb-0.5\"\n      >\n        Name\n      </InputLabel>\n      <Input\n        id=\"component-outlined\"\n        placeholder=\"Type your name\"\n        slotProps={{\n          root: {\n            className:\n              'mt-0 -ml-0.5 px-2 h-10 border-1 border-neutral-300 dark:border-neutral-700 rounded-md has-[input:focus-visible]:outline-2 has-[input:focus-visible]:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm before:hidden after:hidden',\n          },\n          input: {\n            className:\n              'placeholder:opacity-100 placeholder:text-neutral-400 dark:placeholder:text-neutral-500',\n          },\n        }}\n      />\n      <FormHelperText className=\"ml-0\">Some important helper text</FormHelperText>\n    </FormControl>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 33,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/FormControl",
      "@mui/material/InputLabel",
      "@mui/material/Input",
      "@mui/material/FormHelperText"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
